import { render, staticRenderFns } from "./GuideImg.vue?vue&type=template&id=231a1458&scoped=true&"
import script from "./GuideImg.vue?vue&type=script&lang=js&"
export * from "./GuideImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231a1458",
  null
  
)

export default component.exports